import { useWindowSize } from '../../hooks/common/useWindowSize'
import { useSidebar } from '../../hooks/useSidebar'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet'

import BookingEditFormProvider from './booking/BookingEditFormProvider'
import Content from './Content'
import Header from './Header'

const CustomSidebar = () => {
  const { sidebar, closeSidebar } = useSidebar()
  const { width } = useWindowSize()

  const isMobile = width <= 768
  const isTablet = width <= 1024 && width > 768
  const widthClass = isMobile ? 'w-full max-w-full' : isTablet ? 'sm:max-w-xl' : 'sm:max-w-2xl'

  return (
    <Sheet open={sidebar.open} onOpenChange={(open) => !open && closeSidebar()}>
      <SheetContent side="right" className={`${widthClass} flex flex-col overflow-hidden`}>
        <BookingEditFormProvider>
          <SheetHeader className="shrink-0">
            <SheetTitle className="sr-only">
              <Header />
            </SheetTitle>
            <div className="flex items-center">
              <Header />
            </div>
          </SheetHeader>
          <div
            className="mt-4 flex min-h-0 grow flex-col"
            style={
              {
                WebkitOverflowScrolling: 'touch',
                touchAction: 'pan-y',
              } as React.CSSProperties
            }
          >
            <Content />
          </div>
        </BookingEditFormProvider>
      </SheetContent>
    </Sheet>
  )
}

export default CustomSidebar
